<template>
    <div>
        <div :class="{ 'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 text-capitalize">
                            {{ title }}
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-user"></i>
                                    </label>
                                    <multiselect
                                        :value="selectedStaff"
                                        label="text"
                                        track-by="staffID"
                                        :options="staffs"
                                        :searchable="true"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        openDirection="below"
                                        :disabled="this.dataID ? true : false"
                                        @select="onStaffChange">
                                        <template slot="option" slot-scope="{ option }">
                                            {{ option.text }}
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="h5">Start Date</label>
                            <date-range-picker
                                class="w-100"
                                ref="picker"
                                v-model="startDate"
                                :opens="'right'"
                                :singleDatePicker="true"
                                :timePicker="false"
                                :showDropdowns="true"
                                :ranges="false"
                                :always-show-calendars="true"
                                :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                                :autoApply="true"
                                :disabled="this.dataID ? true : false"
                                :append-to-body="true"
                                @update="onStartDateSelect">
                            </date-range-picker>
                        </div>

                        <div class="form-group">
                            <label class="h5">End Date</label>
                            <date-range-picker
                                class="w-100"
                                ref="picker"
                                v-model="endDate"
                                :minDate="endDateMin"
                                :opens="'right'"
                                :singleDatePicker="true"
                                :timePicker="false"
                                :showDropdowns="true"
                                :ranges="false"
                                :always-show-calendars="true"
                                :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                                :autoApply="true"
                                :disabled="this.dataID ? true : false"
                                :append-to-body="true"
                                @update="onEndDateSelect">
                            </date-range-picker>
                        </div>

                        <div class="form-group">
                            <label class="h5">Leave Type</label>
                            <multiselect
                                :value="selectedType"
                                label="type"
                                track-by="typeID"
                                :options="types"
                                :searchable="true"
                                :show-labels="false"
                                :allow-empty="false"
                                openDirection="above"
                                :disabled="this.dataID ? true : false"
                                @select="onTypeChange">
                                <template slot="option" slot-scope="{ option }">
                                    {{ option.type }}
                                </template>
                            </multiselect>
                        </div>

                        <div class="form-group">
                            <label class="h5">Leave Amount</label>
                            <input class="form-control" type="number" v-model="day">
                        </div>

                    </div>
                    <div class="modal-footer">
                        <div class="row w-100 no-gutters">

                            <div v-if="dataID" class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-danger waves-effect waves-themed mr-2"
                                    @click="showDeleteModal(dataID)">
                                    <i class="fal fa-trash"></i>
                                </button>
                            </div>

                            <div class="col">
                            </div>

                            <div class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-secondary waves-effect waves-themed"
                                    @click="toggleModal = false">
                                    {{ $t('button_link.cancel') }}
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-primary waves-effect waves-themed ml-2"
                                    @click="submitForm"
                                    :disabled="saveable">
                                    Save
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteFile"></deleteModal>
    </div>
</template>
<script>
import moment from 'moment'
import DeleteModal from './../../Delete_Modal.vue'
import DateRangePicker from 'vue2-daterange-picker'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'ConsentFormForm',
    props: {
        isEdit: Boolean
    },
    components: {
        DateRangePicker,
        DeleteModal,
    },
    data() {
        return {
            toggleModal: false,

            title: '',
            saveable: false,

            dataID: 0,
            staffsAll: [],
            staffsFiltered: [],
            staffs: [],
            selectedStaff: {},
            startDate: {},
            endDate: {},
            endDateMin: null,
            types: [],
            selectedType: {},
            day: '',
        }
    },
    methods: {
        setStaffList(staffs) {
            this.staffsAll = staffs
            this.staffsFiltered = staffs.filter(k => k['enable'] && !k['deleteDate'])
        },
        setStaff(staff) {
            if(!staff || !staff['staffID']) {
                return
            }
            this.selectedStaff = staff
        },
        setLeaveTypes(types) {
            this.types = types
            this.selectedType = types[0]
        },

        showModal(data) {
            this.toggleModal = true

            if (data) {
                this.title = 'Edit Staff Scheme'

                this.dataID = data['schemeID']
                this.startDate = { startDate: moment.unix(data['startDate']), endDate: moment.unix(data['startDate']) }
                this.endDate = { startDate: moment.unix(data['endDate']), endDate: moment.unix(data['endDate']) }
                this.selectedType = this.types.find(k => k['typeID'] === data['typeID'])
                this.day = data['total']

                this.staffs = this.staffsAll
                this.selectedStaff = this.staffsAll.find(k => k['staffID'] === data['staffID']) || null

                return
            }

            this.title = 'Add Staff Scheme'

            this.dataID = 0
            this.startDate = { startDate: null, endDate: null }
            this.endDate = { startDate: null, endDate: null }
            this.selectedType = {}
            this.day = ''

            this.staffs = this.staffsFiltered
        },
        closeModal(isError) {
        },

        onStaffChange(val) {
            this.selectedStaff = val
        },
        onStartDateSelect() {
            if(this.endDate.endDate && moment(this.endDate.endDate).unix() < moment(this.startDate.startDate).unix()) {
                let temp = moment(this.startDate.startDate).add(1, 'day').endOf('day')
                this.endDate = { startDate: temp, endDate: temp }
            }
        },
        onEndDateSelect() {
            if(this.startDate.startDate && moment(this.endDate.endDate).unix() < moment(this.startDate.startDate).unix()) {
                let temp = moment(this.endDate.endDate).subtract(1, 'day').startOf('day')
                this.startDate = { startDate: temp, endDate: temp }
            }
        },
        onTypeChange(val) {
            this.selectedType = val
        },

        submitForm() {
            if (this.dataID) {
                this.updateData()
                return
            }

            this.addData()
        },
        addData() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/scheme',
                headers: { token: $vm.$session.get('token') },
                data: {
                    startDate: moment(this.startDate.startDate).startOf('day').unix(),
                    endDate: moment(this.endDate.startDate).endOf('day').unix(),
                    total: this.day,
                    typeID: this.selectedType['typeID'],
                },
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        var message = 'Successfully add staff scheme'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onDataChange')
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        updateData() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/scheme/' + this.dataID + '/update',
                headers: { token: $vm.$session.get('token') },
                data: {
                    startDate: moment(this.startDate.startDate).startOf('day').unix(),
                    endDate: moment(this.endDate.startDate).endOf('day').unix(),
                    total: this.day,
                    typeID: this.selectedType['typeID'],
                }
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        var message = 'Successfully update staff scheme'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onDataChange')
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        showDeleteModal(dataID) {
            this.dataID = dataID
            var title = this.$i18n.t('header.delete_file')
            var message = 'Are you sure you want to delete this staff scheme?'
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteFile() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/scheme/' + this.dataID + '/delete',
                headers: { token: $vm.$session.get('token') },
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        this.title = ''

                        var message = 'Successfully delete staff scheme'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onDataChange')

                        this.$refs.deleteModal.toggleModal = false
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>
.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}

#start-datepicker__dialog_ {
    display: none !important;
}

#start-datepicker__dialog_.show {
    display: block !important;
}

#end-datepicker__dialog_ {
    display: none !important;
}

#end-datepicker__dialog_.show {
    display: block !important;
}
</style>